import Vue from "vue";
import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";

Vue.use(VueApollo);

const defaultClient = new ApolloClient({
  uri: "http://localhost:4000/graphql"
});

export default new VueApollo({ defaultClient });
